/* Component Dependencies */
var travelerArticlesTrendingTemplate = require('templates/travelerArticlesTrending.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');
require('libs/jquery.dotdotdot');

AriesComponent.create({

    type: 'travelerArticlesTrending',

    template: {
        'travelerArticlesTrending': travelerArticlesTrendingTemplate
    },
    unBindEvents: function($) {
        $('*[data-component-id="' + this.$el.data('component-id') + '"]').off();
        $('*[data-component-id="' + this.$el.data('component-id') + '"] *').off();
    },
    bindEvents: function() {
        var _self = this;
        _self.$el.find('.js-traveller-article').each(function(index, element) {
            var $element = $(element);

            // applying multiline elipsis
            $element.find('.js-article-detail p').dotdotdot();
        });
        _self.windowResize();
    },

    windowResize: function () {
        var _self = this;
        $( window ).resize(function() {
            _self.$el.find('.js-traveller-article').each(function(index, element) {
                var $element = $(element);
                // applying multiline elipsis
                $element.find('.js-article-detail p').dotdotdot();
            });
        });
    }
    
});